export default class Api {

    static searchUsers(input) {
        if (input.length < 4) {
            return Promise.resolve([]);
        }

        return fetch(`/api/user/search/${input}`, { credentials: 'same-origin' })
            .then((response) => response.json())
            .then((json) => {
                return json;
            });
    }

    static getCurrentUser() {
        return fetch(`/api/user/current`, { credentials: 'same-origin' })
            .then((response) => response.json())
            .then((json) => {
                //json.roles = [];
                return json;
            });
    }

    static searchPatients(input) {
        if (input.length < 4) {
            return Promise.resolve([]);
        }

        return fetch(`/api/patient/search/${input}`, { credentials: 'same-origin' })
            .then((response) => response.json())
            .then((json) => {
                return json;
            });
    }

    static getPatient(patientId) {
        return fetch(`/api/patient/${patientId}`, { credentials: 'same-origin' })
            .then((response) => response.json())
            .then((json) => {
                return json;
            });
    }

    static searchProcedures(input) {
        if (input.length < 3) {
            return Promise.resolve([]);
        }

        return fetch(`/api/procedure/search/${input}`, { credentials: 'same-origin' })
            .then((response) => response.json())
            .then((json) => {
                json.forEach(item => {
                    item.label = `${item.code} - ${item.name}`;
                    item.units = 1;
                });

                return json;
            });
    }

    static getProviders() {
        return fetch(`/api/provider`, { credentials: 'same-origin' })
            .then((response) => response.json())
            .then((json) => {
                return json;
            });
    }

    static getInsurances() {
        return fetch(`/api/insurance`, { credentials: 'same-origin' })
            .then((response) => response.json())
            .then((json) => {
                return json;
            });
    }

    static getLocations() {
        return fetch(`/api/location`, { credentials: 'same-origin' })
            .then((response) => response.json())
            .then((json) => {
                return json;
            });
    }

    static getCode(code, insurance, location, provider) {

        insurance = insurance ?? { type: '' };
        location = location ?? { departmentId: 0, isFacility: false, isTrauma: false };
        provider = provider ?? { type: '' };

        //insurance = { ...insurance }
        //insurance.type = insurance?.type ?? '';
        //location.departmentId = location?.departmentId ?? 0;
        //location.isFacility = location?.isFacility ?? false;
        //location.isTrauma = location?.isTrauma ?? false;
        //provider.type = provider?.type ?? '';

        console.debug(`Getting Cpt Info based on code: ${code}, insurance: {type: ${insurance.type}}, location: {departmentId: ${location.departmentId}, isFacility: ${location.isFacility}, isTrauma: ${location.isTrauma}}, provider: {type: ${provider.type}}`);

        return fetch('/api/procedure',
            {
                credentials: 'same-origin',
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ProcCode: code,
                    Insurance: insurance,
                    Location: location,
                    Provider: provider
                })
            })
            .then((response) => response.json())
            .then((result) => {
                console.debug(JSON.stringify(result));
                return result;
            });
    }

    static getSummary(estimateId) {

        if (estimateId) {
            return fetch(`/api/Summary/${estimateId}`, { credentials: 'same-origin' })
                .then((response) => response.json())
                .then((json) => {
                    // Transform parentIds into object refs
                    json?.codeList?.forEach((item, _, array) => {
                        if (item.ParentId !== null) {
                            item.Parent = array[item.ParentId];
                        }
                        delete item.ParentId;
                    })
                    return json;
                });
        } else {
            return Promise.resolve(null);
        }
    }

    static saveSummary(summaryData) {

        // Transform Parent refs into parentIds
        summaryData?.codeList.forEach((item, _, array) => {
            let parentId = array.indexOf(item.parent);
            if (parentId === -1) {
                parentId = null;
            }
            item.parentId = parentId;
        });

        // Workaround for issue deleting parent property from codeList.
        // Use stringify replacer function to return any property not called 'parent'
        const payload = JSON.stringify(summaryData, (key, value) => {
            return (key !== 'parent') ? value : undefined;
        });

        return fetch(`/api/Summary`,
            {
                credentials: 'same-origin',
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: payload
            }).then(response => {
                if (response.ok) {
                    return Promise.resolve(response.json(), response.status);
                    // Promise.resolve({}); // Don't send response.json() as it is blank from this web service call.
                } else {
                    return Promise.reject(response.json(), response.status);
                }
            });
    }

    static searchSummariesById(id) {

        return fetch(`/api/Summary/${id}`, { credentials: 'same-origin' })
            .then((response) => response.json())
            .then((json) => {
                return json;
            });
    }

    static searchSummariesByPatient(input) {

        return fetch(`/api/Summary/ByPatient/${input}`, { credentials: 'same-origin' })
            .then((response) => response.json())
            .then((json) => {
                return json;
            });
    }

    static searchSummariesByUser(input) {

        return fetch(`/api/Summary/ByUser/${input}`, { credentials: 'same-origin' })
            .then((response) => response.json())
            .then((json) => {
                return json;
            });
    }

    static getInsuranceMappings() {

        return fetch(`/api/admin/insuranceMappings`, { credentials: 'same-origin' })
            .then((response) => response.json())
            .then((json) => {
                return json;
            });
    }

    static getAllowableScheduleTypes() {

        return fetch(`/api/admin/allowableTypes`, { credentials: 'same-origin' })
            .then((response) => response.json())
            .then((json) => {
                return json;
            });
    }

    // Save insurance mapping override
    static saveMappedInsurance(obj) {  
        
        const payload = { name: obj.name, mappedType: obj.mappedType };

        //console.log(payload);

        return fetch(`/api/Admin`,
            {
                credentials: 'same-origin',
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            }).then(response => {
                //console.log(response);
                if (response.ok) {
                    
                    return Promise.resolve(response.json(), response.status);
                    // Promise.resolve({}); // Don't send response.json() as it is blank from this web service call.
                } else {
                    return Promise.reject(response.json(), response.status);
                }
            });
    }

    static getFeeSchedules() {

        return fetch(`/api/admin/feeschedules`, { credentials: 'same-origin' })
            .then((response) => response.json())
            .then((json) => {
                return json;
            });
    }

    static getCodeFeeScheduleMapping(code, insurance, location, provider) {

        insurance = insurance ?? { type: '' };
        location = location ?? { departmentId: 0, isFacility: false, isTrauma: false };
        provider = provider ?? { type: '' };

        return fetch('api/admin/procedurefeeschedulematches',
            {
                credentials: 'same-origin',
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ProcCode: code,
                    Insurance: insurance,
                    Location: location,
                    Provider: provider
                })
            })
            .then((response) => response.json())
            .then((result) => {
                return result;
            });
    }

    constructor(props) {
        this.props = props;
    }

    calculateRemainingDeductible() {
        return Math.floor((+(this.props.deductible) - +(this.props.paidIn)) * 100) / 100;
    }

    calculateCharges() {
        return this.props.codeList.reduce((sum, row) => sum + (+(row.units) * +(row.chargeAmount)), 0);
    }

    calculateAllowables() {
        // Sort by Wrvu desc, then AltAmount desc
        // In the case of tie, the highest AltAmount wins and will be discounted less
        const sortedCodes = this.props.codeList.slice().sort((a, b) => b.wrvu - a.wrvu || (b.units * b.altAmount) - (a.units * a.altAmount));

        let sum = 0.0;
        let foundMultipleProcedureCount = 0;
        for (let i = 0; i < sortedCodes.length; i++) {
            const row = sortedCodes[i];

            let amount = +(row.units) * +(row.altAmount);

            // Process multiple procedures
            // This is only valid when the insurance is selected and NOT self pay
            if (this.props.selectedInsurance && this.props.selectedInsurance?.type && !this.props.selectedInsurance.isSelfPay) {
                if (this.isMultipleProcedure(row.code)) {
                    // Discount the first multiple procedure by 0%, 2nd by 50%, 3rd and up by 75%
                    foundMultipleProcedureCount++;
                    if (foundMultipleProcedureCount === 2) {
                        amount *= 0.5;
                    }
                    else if (foundMultipleProcedureCount >= 3) {
                        amount *= 0.25;
                    }
                }
            }

            sum += amount;
        }

        return sum;
    }

    calculateMaxOutOfPocketRemaining() {
        return Math.floor((+(this.props.maxOutOfPocket) - +(this.props.maxOutOfPocketPaidIn)) * 100) / 100;
    }

    calculateDeductibleCost() {
        return Math.min(this.calculateRemainingDeductible(), this.calculateAllowables());
    }

    calculateCoinsuranceCost() {
        return (+(this.props.coinsurance) * (this.calculateAllowables() - this.calculateDeductibleCost()));
    }

    calculateCopayCost() {
        return (+(this.props.copay));
    }

    calculateInsuranceBalance() {
        return this.calculateDeductibleCost() + this.calculateCoinsuranceCost() + this.calculateCopayCost();
    }

    calculateSummaryDeductible() {
        return this.calculateDeductibleCost();
    }

    calculateSummaryCoinsurance() {
        if (this.isInsuranceLowerThanAllowables()) {
            return this.calculateCoinsuranceCost();
        } else {
            return 0;
        }
    }

    calculateSummaryCopay() {
        if (this.isInsuranceLowerThanAllowables()) {
            return this.calculateCopayCost();
        } else {
            return 0;
        }
    }

    calculateOutOfPocketAmount() {
        let balance = this.calculateAllowables();

        // Self pay uses allowables only. Don't consider insurance balance.
        if (!this.props.selectedInsurance?.isSelfPay) {
            // Balance after insurance or the allowables, whichever one is lower
            balance = Math.min(balance, this.calculateInsuranceBalance());
        }

        // If a Max Out Of Pocket is set, cap at the remaining amount.
        if (this.props.maxOutOfPocket) {
            balance = Math.min(balance, this.props.maxOutOfPocketRemaining);
        }

        return balance;
    }

    calculateTotalDue() {
        const debts = (this.props.selectedPatient ? this.props.selectedPatient.balance : 0) + (this.props.selectedPatient ? this.props.selectedPatient.badDebt : 0);

        return +(debts) + +(this.calculateOutOfPocketAmount());
    }

    isInsuranceLowerThanAllowables() {
        const allowables = this.calculateAllowables();
        const balanceAfterInsurance = this.calculateInsuranceBalance();

        return balanceAfterInsurance <= allowables;
    }

    isMultipleProcedure(code) {
        // Multiple procedure codes never start with a character
        if (/^[A-Z]+$/i.test(code.charAt(0))) {
            return false;
        }

        // Multiple procedure codes are not in the range 70000-8999999
        // Trim out character modifiers on the end
        let numericPortion = /[^,]*/.exec(code)[0];
        const numericCode = parseInt(numericPortion);
        // If the code is not well formed, we can't evaluate it properly as a numeric
        if (isNaN(numericCode) || (numericCode >= 70000 && numericCode <= 8999999)) {
            return false;
        }

        // Multiple procedures cannot be an 'add-on' code
        const addOnCodes = [
            '0054T',
            '0055T',
            '0076T',
            '0095T',
            '0098T',
            '0159T',
            '0163T',
            '0164T',
            '0165T',
            '0174T',
            '0189T',
            '0190T',
            '0196T',
            '0205T',
            '0214T',
            '0215T',
            '0217T',
            '0218T',
            '0222T',
            '0229T',
            '0231T',
            '0290T',
            '0346T',
            '0361T',
            '0363T',
            '0365T',
            '0367T',
            '0369T',
            '0374T',
            '0376T',
            '0396T',
            '0397T',
            '0399T',
            '0437T',
            '0439T',
            '0443T',
            '0450T',
            '0466T',
            '0471T',
            '0480T',
            '0482T',
            '0492T',
            '0496T',
            '01953',
            '01968',
            '01969',
            '10036',
            '11001',
            '11008',
            '11045',
            '11046',
            '11047',
            '11101',
            '11201',
            '11732',
            '11922',
            '13102',
            '13122',
            '13133',
            '13153',
            '14302',
            '15003',
            '15005',
            '15101',
            '15111',
            '15116',
            '15121',
            '15131',
            '15136',
            '15151',
            '15152',
            '15156',
            '15157',
            '15201',
            '15221',
            '15241',
            '15261',
            '15272',
            '15274',
            '15276',
            '15278',
            '15777',
            '15787',
            '15847',
            '16036',
            '17003',
            '17312',
            '17314',
            '17315',
            '19001',
            '19082',
            '19084',
            '19086',
            '19126',
            '19282',
            '19284',
            '19286',
            '19288',
            '19294',
            '19297',
            '20930',
            '20931',
            '20936',
            '20937',
            '20938',
            '20939',
            '20985',
            '22103',
            '22116',
            '22208',
            '22216',
            '22226',
            '22328',
            '22512',
            '22515',
            '22527',
            '22534',
            '22552',
            '22585',
            '22614',
            '22632',
            '22634',
            '22840',
            '22841',
            '22842',
            '22843',
            '22844',
            '22845',
            '22846',
            '22847',
            '22848',
            '22853',
            '22854',
            '22858',
            '22859',
            '22868',
            '22870',
            '26125',
            '26861',
            '26863',
            '27358',
            '27692',
            '29826',
            '31627',
            '31632',
            '31633',
            '31637',
            '31649',
            '31651',
            '31654',
            '32501',
            '32506',
            '32507',
            '32667',
            '32668',
            '32674',
            '33141',
            '33225',
            '33257',
            '33258',
            '33259',
            '33367',
            '33368',
            '33369',
            '33419',
            '33508',
            '33517',
            '33518',
            '33519',
            '33521',
            '33522',
            '33523',
            '33530',
            '33572',
            '33768',
            '33884',
            '33924',
            '33929',
            '33987',
            '34709',
            '34711',
            '34713',
            '34714',
            '34715',
            '34716',
            '34808',
            '34812',
            '34813',
            '34820',
            '34833',
            '34834',
            '35306',
            '35390',
            '35400',
            '35500',
            '35572',
            '35600',
            '35681',
            '35682',
            '35683',
            '35685',
            '35686',
            '35697',
            '35700',
            '36218',
            '36227',
            '36228',
            '36248',
            '36474',
            '36476',
            '36479',
            '36483',
            '36907',
            '36908',
            '36909',
            '37185',
            '37186',
            '37222',
            '37223',
            '37232',
            '37233',
            '37234',
            '37235',
            '37237',
            '37239',
            '37247',
            '37249',
            '37252',
            '37253',
            '38102',
            '38746',
            '38747',
            '38900',
            '43273',
            '43283',
            '43338',
            '43635',
            '44015',
            '44121',
            '44128',
            '44139',
            '44203',
            '44213',
            '44701',
            '44955',
            '47001',
            '47542',
            '47543',
            '47544',
            '47550',
            '48400',
            '49326',
            '49327',
            '49412',
            '49435',
            '49568',
            '49905',
            '50606',
            '50705',
            '50706',
            '51797',
            '52442',
            '56606',
            '57267',
            '58110',
            '58611',
            '59525',
            '60512',
            '61316',
            '61517',
            '61610',
            '61611',
            '61612',
            '61641',
            '61642',
            '61651',
            '61781',
            '61782',
            '61783',
            '61797',
            '61799',
            '61800',
            '61864',
            '61868',
            '62148',
            '62160',
            '63035',
            '63043',
            '63044',
            '63048',
            '63057',
            '63066',
            '63076',
            '63078',
            '63082',
            '63086',
            '63088',
            '63091',
            '63103',
            '63295',
            '63308',
            '63621',
            '64462',
            '64480',
            '64484',
            '64491',
            '64492',
            '64494',
            '64495',
            '64634',
            '64636',
            '64643',
            '64645',
            '64727',
            '64778',
            '64783',
            '64787',
            '64832',
            '64837',
            '64859',
            '64872',
            '64874',
            '64876',
            '64901',
            '64902',
            '64913',
            '65757',
            '66990',
            '67225',
            '67320',
            '67331',
            '67332',
            '67334',
            '67335',
            '67340',
            '69990'
        ];
        if (addOnCodes.indexOf(code) > -1) {
            return false;
        }

        return true;
    }
}